export const gitCommit = 'fe6b465c'
